import axios from "axios";
import { API_URL } from "../variables";
import { toast } from "react-toastify";
import axiosInstance from "../utils/axiosConfig";

export const FETCH_REFERRAL_BY_CODE_REQUEST = "FETCH_REFERRAL_BY_CODE_REQUEST";
export const FETCH_REFERRAL_BY_CODE_SUCCESS = "FETCH_REFERRAL_BY_CODE_SUCCESS";
export const FETCH_REFERRAL_BY_CODE_FAILURE = "FETCH_REFERRAL_BY_CODE_FAILURE";

export const CREATE_REFERRAL_REQUEST = "CREATE_REFERRAL_REQUEST";
export const CREATE_REFERRAL_SUCCESS = "CREATE_REFERRAL_SUCCESS";
export const CREATE_REFERRAL_FAILURE = "CREATE_REFERRAL_FAILURE";

export const FETCH_USER_REFERRALS_REQUEST = "FETCH_USER_REFERRALS_REQUEST";
export const FETCH_USER_REFERRALS_SUCCESS = "FETCH_USER_REFERRALS_SUCCESS";
export const FETCH_USER_REFERRALS_FAILURE = "FETCH_USER_REFERRALS_FAILURE";

export const fetchReferralByCode = (code) => async (dispatch) => {
  dispatch({ type: FETCH_REFERRAL_BY_CODE_REQUEST });

  try {
    const response = await axios.post(
      `${API_URL}/api/users/referrals/get-by-code`,
      { code }
    );

    if (response.data.status === "success") {
      dispatch({
        type: FETCH_REFERRAL_BY_CODE_SUCCESS,
        payload: response.data.data,
      });
      return response.data.data;
    } else {
      dispatch({
        type: FETCH_REFERRAL_BY_CODE_FAILURE,
        payload: response.data.message || "Failed to fetch referral data",
      });
      toast.error(response.data.message || "Failed to fetch referral data");
      throw new Error(response.data.message || "Failed to fetch referral data");
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while fetching referral data";
    dispatch({
      type: FETCH_REFERRAL_BY_CODE_FAILURE,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    throw error;
  }
};

export const createReferral = (referralData) => async (dispatch) => {
  dispatch({ type: CREATE_REFERRAL_REQUEST });

  try {
    const token = localStorage.getItem("authToken");
    if (!token) {
      const errorMessage = "You must be logged in to create a referral";
      dispatch({
        type: CREATE_REFERRAL_FAILURE,
        payload: errorMessage,
      });
      toast.error(errorMessage);
      throw new Error(errorMessage);
    }

    const response = await axiosInstance.post(
      `${API_URL}/api/users/referrals/add`,
      {
        code: referralData.code,
        name: referralData.name,
        percentage: referralData.percentage || 10.0,
        status: "active",
      },
      {
        headers: {
          Authorization: token,
        },
      }
    );

    if (response.data.status === "success") {
      dispatch({
        type: CREATE_REFERRAL_SUCCESS,
        payload: response.data.data,
      });
      toast.success(response.data.message || "Referral created successfully!");
      return response.data.data;
    } else {
      dispatch({
        type: CREATE_REFERRAL_FAILURE,
        payload: response.data.message || "Failed to create referral",
      });
      toast.error(response.data.message || "Failed to create referral");
      throw new Error(response.data.message || "Failed to create referral");
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while creating referral";
    dispatch({
      type: CREATE_REFERRAL_FAILURE,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    throw error;
  }
};

export const fetchUserReferrals = () => async (dispatch) => {
  dispatch({ type: FETCH_USER_REFERRALS_REQUEST });

  try {
    const token = localStorage.getItem("authToken");
    if (!token) {
      dispatch({
        type: FETCH_USER_REFERRALS_FAILURE,
        payload: "You must be logged in to view referrals",
      });
      return [];
    }

    const response = await axiosInstance.post(
      `${API_URL}/api/users/referrals/get-user`,
      {},
      {
        headers: {
          Authorization: token,
        },
      }
    );

    if (response.data.status === "success") {
      dispatch({
        type: FETCH_USER_REFERRALS_SUCCESS,
        payload: response.data.data || [],
      });
      return response.data.data || [];
    } else {
      dispatch({
        type: FETCH_USER_REFERRALS_FAILURE,
        payload: response.data.message || "Failed to fetch referrals",
      });
      return [];
    }
  } catch (error) {
    dispatch({
      type: FETCH_USER_REFERRALS_FAILURE,
      payload: error.response?.data?.message || "Failed to fetch referrals",
    });
    return [];
  }
};
